import { render, staticRenderFns } from "./OnBoardingPhases.vue?vue&type=template&id=9ca8a570&"
import script from "./OnBoardingPhases.vue?vue&type=script&lang=js&"
export * from "./OnBoardingPhases.vue?vue&type=script&lang=js&"
import style0 from "./OnBoardingPhases.vue?vue&type=style&index=0&id=9ca8a570&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports